import { memo } from "react";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";

import type { IShareHostRowProps } from "./types";

const ShareHostRowComponent = ({
  hostName,
  hostEmail,
  hostInitials,
  shouldReserveCheckboxSpace,
  shouldReserveMenuSpace,
  hostBadgeLabel,
}: IShareHostRowProps): JSX.Element => {
  return (
    <div className="flex items-center justify-between gap-3">
      <div className="flex min-w-0 flex-1 items-center gap-3">
        {shouldReserveCheckboxSpace && (
          <div className="h-[18px] w-[18px] shrink-0" aria-hidden="true" />
        )}
        <Avatar className="h-9 w-9 shrink-0 border-0 bg-primary/10">
          <AvatarImage src="" />
          <AvatarFallback className="bg-primary/10 text-primary text-xs font-medium">
            {hostInitials}
          </AvatarFallback>
        </Avatar>
        <div className="min-w-0">
          <p className="truncate text-sm font-medium">{hostName}</p>
          <p className="truncate text-xs text-muted-foreground">{hostEmail}</p>
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <Badge className="bg-primary/10 hover:bg-primary/10 px-2.5 py-0.5 text-xs font-medium text-primary">
          {hostBadgeLabel}
        </Badge>
        {shouldReserveMenuSpace && (
          <div className="h-8 w-9 shrink-0" aria-hidden="true" />
        )}
      </div>
    </div>
  );
};

export const ShareHostRow = memo(ShareHostRowComponent);

ShareHostRow.displayName = "ShareHostRow";
